import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class UserRole extends BaseModel {
  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.role = rootStore.roleStore.getById(this.roleId);
  }
}

decorate(UserRole, {
  id: observable,
  userId: observable,
  roleId: observable,
  role: observable,
  expireDate: observable,
  alertDate: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
